import { useContext } from 'react';
import { CurrencyPrecisionContext } from '@/contexts/CurrencyPrecisionContext';
import { localFractionDigits } from '@/utils/currencyPrecision';

/**
 * Resolves how many minor-unit digits a currency has.
 *
 * Always returns a number: the server table is preferred, and anything it does not
 * cover — a code outside the ISO list, or the table not having loaded — falls back
 * to the locally derived precision. Callers never have to handle "not ready yet".
 */
export function useCurrencyFractionDigits(currency: string | null | undefined): number {
    const fractionDigits = useContext(CurrencyPrecisionContext);

    return fractionDigits?.[(currency ?? '').trim().toUpperCase()] ?? localFractionDigits(currency);
}
